import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { AdminProductsController, ProductsController } from './products.controller';
import { PrismaProductsRepository } from './prisma-products.repository';
import { ProductsRepository } from './products.repository';
import { ProductsService } from './products.service';
import { ProductStoreScopeService } from './product-store-scope.service';
import { ReadinessModule } from '../readiness/readiness.module';

@Module({
  // ReadinessModule so a product cannot be created before the store can
  // fulfil and invoice an order — enforced server-side, not just in the UI.
  imports: [AuthModule, ReadinessModule],
  controllers: [ProductsController, AdminProductsController],
  providers: [
    ProductStoreScopeService,
    ProductsService,
    PrismaService,
    {
      provide: ProductsRepository,
      useClass: PrismaProductsRepository,
    },
  ],
  exports: [ProductsRepository],
})
export class ProductsModule {}
